export function normalizeImei(imei: unknown): string | null {
  if (typeof imei === 'number') return String(imei);
  if (typeof imei === 'string') return imei.trim() || null;
  return null;
}
